import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faCloudArrowDown, faCloudArrowUp, faEraser } from '@fortawesome/free-solid-svg-icons';
// import Editor from '@monaco-editor/react';
import Spiner from '../components/Spiner';
import CurrentSheet from '../components/excels/CurrentSheet'
var _ = require('lodash');

const ExcelJson = (props) => {
  const { editorTheme } = props
  const [sheetData, setSheetData] = useState({});
  const [activeTab, setActiveTab] = useState(0);
  const [sheetNames, setSheetNames] = useState([]);
  const [displaySheetData, setDisplaySheetData] = useState({})
  const [fileChangesCount, setFileChangesCount] = useState(0)
  const worker = new Worker(new URL('./../workers/excel.worker.js', import.meta.url));

  // const copyToClipboard = () => {
  //   const currentTabData = displaySheetData[sheetNames[activeTab]]
  //   if (currentTabData) {
  //     const coppiedData = JSON.stringify(currentTabData, null, 2);
  //     navigator.clipboard.writeText(coppiedData);
  //   }
  // };
  // const downloadJsonFile = () => {
  //   const currentTabData = displaySheetData[sheetNames[activeTab]]
  //   if (currentTabData) {
  //     const jsonData = JSON.stringify(currentTabData, null, 2);
  //     const blob = new Blob([jsonData], { type: 'application/json' });
  //     const url = URL.createObjectURL(blob);
  //     const a = document.createElement('a');
  //     a.href = url;
  //     a.download = `${sheetNames[activeTab]}.json`;
  //     a.click();
  //     URL.revokeObjectURL(url);
  //   }
  // };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      return;
    }
    setFileChangesCount(fileChangesCount + 1)
    worker.postMessage(file)
    worker.onmessage = function (event) {
      const tempSheetData = event.data;
      setSheetData(tempSheetData);
      setDisplaySheetData(tempSheetData);
      setActiveTab(0)
    };
  };
  const renderJsonAsHtml = (jsonData) => {
    return JSON.stringify(jsonData, null, 2)
  }

  const handleReset = () => {
    setFileChangesCount(0)
    setSheetData({})
    setDisplaySheetData({})
    setActiveTab(0)
  }
  
  useEffect(() => {
    if (sheetData) {
      const sheetKeys = Object.keys(sheetData)
      setSheetNames(sheetKeys);
    }
  }, [sheetData]);

  return (
    <div className="grid grid-cols-1 my-4 xl:grid-cols-2 xl:gap-4">
      <div className="col-span-2">
        <div className="p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="grid gap-4 mt-4">
            <div className='w-full'>
              <div className="px-4 py-2 text-gray-400 rounded dark:border-gray-600">
                <input id="excel-file-input" accept='.xlsx, .xls' name='file' className='hidden' type="file" onChange={handleFileChange} />
                <button
                  onClick={() => document.querySelector('input[name="file"]').click()}
                  type="button"
                  className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
                >
                  <FontAwesomeIcon icon={faCloudArrowUp}/>
                  &nbsp; Browse excel file
                </button>
                { sheetData[sheetNames[activeTab]] && (
                  <button
                    disabled={!sheetData[sheetNames[activeTab]]}
                    onClick={handleReset}
                    type="button"
                    className="text-white ml-4 bg-gray-400 hover:bg-gray-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
                  >
                    <FontAwesomeIcon icon={faEraser}/>
                    &nbsp; Reset
                  </button>
                ) }
                {/* { (sheetData[sheetNames[activeTab]]) && (
                  <button
                    disabled={!sheetData[sheetNames[activeTab]]}
                    onClick={copyToClipboard}
                    type="button"
                    className="text-white ml-4 bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
                  >
                    <FontAwesomeIcon icon={faCopy}/>
                    &nbsp; Copy JSON
                  </button>
                )}
                { sheetData[sheetNames[activeTab]] && (
                  <button
                    disabled={!sheetData[sheetNames[activeTab]]}
                    onClick={downloadJsonFile}
                    type="button"
                    className="text-white ml-4 bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
                  >
                    <FontAwesomeIcon icon={faCloudArrowDown}/>
                    &nbsp; Download JSON file
                  </button>
                ) } */}
              </div>
              <Spiner visible={_.isEmpty(sheetNames) && fileChangesCount > 0} />
              {/* { !_.isEmpty(sheetNames) && (
                <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
                  <h3 className='uppercase border-l-4 border-yellow-600 p-2'>JSON View</h3>
                </div>
              ) } */}
              { !_.isEmpty(sheetNames) && (
                <>
                  <ul className="flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:text-gray-400 dark:border-gray-700">
                    <li className="mr-2">
                      <button className='inline-block p-4 rounded-t-lg border-b-2 border-transparent '>Sheet Name</button>
                    </li>
                    { sheetNames.map((sheetName, index) => {
                      return (
                        <li className="mr-2">
                          <button
                            onClick={() => setActiveTab(index)}
                            className={`inline-block p-4 rounded-t-lg border-b-2 ${
                              activeTab === index
                                ? 'border-blue-600 text-blue-600 dark:text-blue-500 dark:border-blue-500'
                                : 'border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300'
                            }`}
                          >
                            {sheetName}
                          </button>
                        </li>
                      )
                    })}
                  </ul>
                  <div className="p-4 bg-gray-50 dark:bg-gray-800">
                    { sheetNames.map((sheetName, index) => {
                      if (activeTab !== index) {
                        return <div/>
                      }
                      return (
                        <div className="px-4 py-2 text-gray-400 rounded dark:border-gray-600" key={index}>
                          {/* <Editor
                            value={renderJsonAsHtml(displaySheetData[sheetName])}
                            height="80vh"
                            language="json"
                            theme={editorTheme}
                            className="block p-2.5 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          /> */}
                          <CurrentSheet
                            displaySheetData={displaySheetData}
                            editorTheme={editorTheme}
                            sheetName={sheetName}
                          />
                        </div>
                      )
                    })}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExcelJson;
